import { jsx as _jsx } from "react/jsx-runtime";
export function AttachFile() {
  return /*#__PURE__*/_jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M15.7222 7.16829L7.23385 15.6015C6.95283 15.9046 6.80184 16.3016 6.81214 16.7104C6.82244 17.1192 6.99324 17.5085 7.28919 17.7976C7.58513 18.0868 7.98354 18.2537 8.40194 18.2638C8.82033 18.2738 9.22667 18.1263 9.53681 17.8517L19.6556 7.82543C20.2176 7.21935 20.5196 6.42531 20.499 5.60769C20.4784 4.79007 20.1368 4.01151 19.5449 3.43319C18.953 2.85487 18.1562 2.5211 17.3194 2.50097C16.4826 2.48084 15.67 2.77589 15.0497 3.32505L4.93088 13.3513C4.0147 14.2465 3.5 15.4606 3.5 16.7266C3.5 17.9926 4.0147 19.2067 4.93088 20.1019C5.84706 20.9971 7.08966 21.5 8.38533 21.5C9.681 21.5 10.9236 20.9971 11.8398 20.1019L20.2059 11.9475",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  });
}